import {type PayloadAction, createSlice} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

export type TCustomControlRatiosSliceState = {
  selectedDocumentsIds: string[];
  showCustomCRColumn: boolean;
  parentDocUrl: string | undefined;
}

export const CUSTOM_CONTROL_RATIOS_SLICE = 'CUSTOM_CONTROL_RATIOS_SLICE';

const initialState: TCustomControlRatiosSliceState = {
    selectedDocumentsIds: [],
    showCustomCRColumn: false,
    parentDocUrl: undefined,
};

export const customControlRatiosSlice = createSlice({
    name: CUSTOM_CONTROL_RATIOS_SLICE,
    initialState,
    reducers: {
        setSelectedDocumentsIds: (state, action: PayloadAction<string[]>) => {
            state.selectedDocumentsIds = action.payload;
        },
    },
});

export const selectDocumentsIds = (state: TAppState) => state.CUSTOM_CONTROL_RATIOS_SLICE.selectedDocumentsIds;

export const {reducer: customControlRatiosReducer} = customControlRatiosSlice;
export const {
    setSelectedDocumentsIds,
} = customControlRatiosSlice.actions;
